import { Thread } from "../../../../types"
import { initialMsgNotReplied } from "../../../utils"
import Badge from "../../badge"
import EventsTooltip from "../events-tooltip"
import If from "../../if"
import AfterHoursBadge from "./after-hours"

const ThreadStatus = ({ thread }: { thread: Thread }): JSX.Element => {
  if (thread.status === "disabled")
    return (
      <span>
        ⛔<i className="sr-only">Thread Disabled</i>
      </span>
    )

  if (thread.status === "deleted") return <Badge.Warning>Deleted</Badge.Warning>
  if (thread.status === "takeover") return <Badge.Info>Takeover</Badge.Info>

  return <></>
}

interface Props {
  thread: Thread
}

const Badges = ({ thread }: Props) => {
  const notReplied = initialMsgNotReplied(thread)

  return (
    <div className="flex items-center gap-1 mt-2">
      <If
        condition={notReplied}
        then={<Badge.Danger>Not Replied</Badge.Danger>}
        elseCondition={thread.status === "scheduled"}
        else={<AfterHoursBadge />}
        default={<Badge.Success>Replied</Badge.Success>}
      />
      <ThreadStatus thread={thread} />
      <EventsTooltip events={thread.events} />
    </div>
  )
}

export default Badges
